import { createContext, useContext } from 'react';

const RootElementContext = createContext<HTMLElement | null>(null);

export const RootElementProvider = RootElementContext.Provider;

export const useRootElement = (): HTMLElement | null => {
  return useContext(RootElementContext);
};
